import {stringToNumber} from "@into/into-common-utils";

import {
    CONFIG_SYSTEM_DEFAULTS,
    CONFIG_SYSTEM_KEYS,
    CONFIG_SYSTEM_NUMBER_KEYS,
} from "../configs/settings/system.config";

const SYSTEM_CONFIG_KEY_ALIASES = {
    deletedResourceRetentionDays: "DELETED_RESOURCE_RETENTION_DAYS",
};

const parseConfigValue = (configKey, configValue) => {
    if (configValue === true || configValue === false) {
        return configValue;
    }

    if (configValue === "true" || configValue === "TRUE") {
        return true;
    }
    if (configValue === "false" || configValue === "FALSE") {
        return false;
    }

    if (CONFIG_SYSTEM_NUMBER_KEYS.includes(configKey)) {
        return stringToNumber(configValue);
    }

    return configValue;
};

const getConfigKey = (item) => (
    item?.["systemConfig.configKey"]
    || item?.configKey
    || item?.key
);

const getConfigValue = (item) => (
    item?.["systemConfig.configValue"]
    ?? item?.configValue
    ?? item?.value
);

const normalizeConfigKey = (configKey) => SYSTEM_CONFIG_KEY_ALIASES[configKey] || configKey;

const parseConfigEntry = (configs, item) => {
    const configKey = normalizeConfigKey(getConfigKey(item));
    if (!CONFIG_SYSTEM_KEYS.includes(configKey)) {
        return;
    }

    configs[configKey] = parseConfigValue(configKey, getConfigValue(item));
};

const parseConfigList = (configList) => {
    if (!Array.isArray(configList) || configList.length === 0) {
        return {};
    }

    return configList.reduce((configs, item) => {
        parseConfigEntry(configs, item);
        return configs;
    }, {});
};

const parseConfigObject = (configObject) => {
    if (!configObject || Array.isArray(configObject) || typeof configObject !== "object") {
        return {};
    }

    return Object.entries(configObject).reduce((configs, [rawKey, value]) => {
        const configKey = normalizeConfigKey(rawKey);
        if (!CONFIG_SYSTEM_KEYS.includes(configKey)) {
            return configs;
        }

        configs[configKey] = parseConfigValue(configKey, value);
        return configs;
    }, {});
};

export const parseSystemConfig = (
    systemConfigPayload,
    initialSystemConfig = CONFIG_SYSTEM_DEFAULTS,
) => {
    const parsedSystemConfig = Array.isArray(systemConfigPayload)
        ? parseConfigList(systemConfigPayload)
        : parseConfigObject(systemConfigPayload);

    return {
        ...initialSystemConfig,
        ...parsedSystemConfig,
    };
};
